import { apiUrl } from "../../config/backendFeatures";
import { api } from "../axios";

/** B11 — blocks live on the server: chat, notifications and listings respect them everywhere. */
export interface ServerBlockedUser {
  id: number;
  name: string | null;
  avatar: string | null;
  blockedAt: string;
}

export const blockUserApi = (id: number) => api.post(apiUrl(`/api/users/${id}/block`));
export const unblockUserApi = (id: number) => api.delete(apiUrl(`/api/users/${id}/block`));
export const getBlockedUsersApi = async (): Promise<ServerBlockedUser[]> => {
  const res = await api.get(apiUrl("/api/users/blocked"));
  return Array.isArray(res.data?.list) ? res.data.list : [];
};
